var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',{attrs:{"cmpt":"Spacer","showBorder":_vm.showBorder}},[_c('SpacerRow',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }